import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class AdminA11yScannersNewRoute extends Route {
  // Services
  @service breadcrumb;

  // Hooks
  model() {
    return this.breadcrumb.findRouteModelOrCreateRecord('a11y-scanner');
  }

  afterModel(model) {
    this.breadcrumb.registerDetailRoute(model);
  }
}
